module.exports = __webpack_public_path__ + "static/18-2a6158f9706db9f16e561a76a85201da.png";